 import React, { useState, useEffect } from "react";
import { logApi } from "../../api/Api";

const PvDgSyncSvg = ({ svgColor }) => {
    const [logData, setLogData] = useState(null); // Initialize as null or an object
    const [credentials, setCredentials] = useState({
        LOGIN_ID: localStorage.getItem("LoginID"),
        LOC_CODE: localStorage.getItem("LCODE"),
        PASS_KEY: localStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
        WEB_KEY: localStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
    });

    const fetchLogData = async () => {
        try {
            const res = await logApi(credentials);
            if (res?.TOT_LIVE_KW_NEW && Array.isArray(res.TOT_LIVE_KW_NEW)) {
                // Assuming you need the first object in the array
                setLogData(res.TOT_LIVE_KW_NEW[0]);
            } else {
                setLogData(null); // Handle no data scenario
            }
        } catch (error) {
            console.error("Error fetching log data:", error);
            setLogData(null); // Handle error scenario
        }
    };

    useEffect(() => {
        fetchLogData();
    }, [credentials]);



    // Determine the color for the SOLAR value
    const solarColor =
        logData?.SOLAR == null
            ? "gray" // No data
            : logData.SOLAR <= 0
                ? "red" // Solar < 1
                : "green"; // Solar >= 1

    // Determine the color for the LOAD value
    const loadColor =
        logData?.TOTAL_LOAD == null
            ? "gray" // No data
            : logData.TOTAL_LOAD <= 0
                ? "red" // Solar < 1
                : "green"; // Solar >= 1


    // Determine the color for the DG value
    const dgColor =
        logData?.GenSet == null
            ? "gray" // No data
            : logData.GenSet <= 0
                ? "red" // Solar <= 0
                : "green"; // Solar > 0




    return (
        <>
        
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="100%" height="100%" viewBox="0 280 1008.000000 535.000000"
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M2354 7117 c-7 -20 -2 -47 11 -50 14 -3 19 43 6 56 -7 7 -12 6 -17
-6z" fill={solarColor}/>
<path d="M2240 7089 c0 -20 21 -49 36 -49 13 0 13 4 -1 30 -15 29 -35 40 -35
19z" fill={solarColor}/>
<path d="M2456 7075 c-19 -30 -20 -35 -3 -35 16 0 40 47 28 55 -5 2 -16 -6
-25 -20z" fill={solarColor}/>
<path d="M2326 7020 c-107 -33 -130 -181 -37 -247 12 -8 23 -13 25 -12 1 2 11
33 22 69 l20 65 72 3 c78 3 83 8 60 57 -22 49 -105 82 -162 65z" fill={solarColor}/>
<path d="M2160 7000 c0 -14 48 -35 58 -26 8 9 -26 36 -45 36 -7 0 -13 -5 -13
-10z" fill={solarColor}/>
<path d="M2524 6996 c-10 -8 -16 -18 -11 -22 8 -8 57 15 57 28 0 13 -24 9 -46
-6z" fill={solarColor}/>
<path d="M2130 6890 c0 -5 14 -10 30 -10 17 0 30 5 30 10 0 6 -13 10 -30 10
-16 0 -30 -4 -30 -10z" fill={solarColor}/>
<path d="M2370 6855 c-5 -14 -13 -37 -16 -51 -6 -25 -6 -25 51 -23 31 1 58 7
60 13 2 6 6 28 10 49 l6 37 -51 0 c-45 0 -52 -3 -60 -25z" fill={solarColor}/>
<path d="M2505 6868 c-3 -7 -6 -29 -7 -48 l-3 -35 55 0 55 0 6 43 c3 23 3 44
1 47 -11 11 -103 4 -107 -7z" fill={solarColor}/>
<path d="M2647 6873 c-4 -3 -7 -25 -7 -48 l0 -42 65 -2 c74 -2 82 5 71 64 l-7
35 -58 0 c-32 0 -61 -3 -64 -7z" fill={solarColor}/>
<path d="M2802 6833 l3 -48 54 -3 c29 -2 57 0 61 5 4 4 3 27 -2 51 l-9 42 -55
0 -55 0 3 -47z" fill={solarColor}/>
<path d="M2944 6838 c4 -22 9 -45 12 -50 7 -10 101 -11 108 0 2 4 -4 27 -14
50 -18 41 -20 42 -66 42 l-47 0 7 -42z" fill={solarColor}/>
<path d="M2176 6795 c-11 -8 -17 -18 -13 -22 9 -8 57 14 57 27 0 14 -22 12
-44 -5z" fill={solarColor}/>
<path d="M2326 6713 c-9 -26 -16 -48 -16 -50 0 -2 29 -3 64 -3 l63 0 10 50 10
50 -57 0 -58 0 -16 -47z" fill={solarColor}/>
<path d="M2473 6710 l-10 -50 68 0 c61 0 69 2 69 19 0 10 3 33 6 50 l7 31 -65
0 -65 0 -10 -50z" fill={solarColor}/>
<path d="M2630 6710 l0 -50 81 0 82 0 -7 38 c-3 20 -6 43 -6 50 0 8 -22 12
-75 12 l-75 0 0 -50z" fill={solarColor}/>
<path d="M2810 6726 c0 -61 6 -66 77 -66 l64 0 -6 38 c-11 63 -10 62 -75 62
l-60 0 0 -34z" fill={solarColor}/>
<path d="M2960 6748 c0 -7 5 -30 11 -50 l10 -38 59 0 c66 0 66 1 48 61 l-11
39 -59 0 c-40 0 -58 -4 -58 -12z" fill={solarColor}/>
<path d="M2248 6715 c-6 -14 -8 -28 -4 -33 9 -8 36 26 36 45 0 22 -20 14 -32
-12z" fill={solarColor}/>
<path d="M3513 6643 c15 -2 37 -2 50 0 12 2 0 4 -28 4 -27 0 -38 -2 -22 -4z" fill={svgColor}/>
<path d="M3658 6643 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z" fill={svgColor}/>
<path d="M3798 6643 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z" fill={svgColor}/>
<path d="M3943 6643 c15 -2 37 -2 50 0 12 2 0 4 -28 4 -27 0 -38 -2 -22 -4z" fill={svgColor}/>
<path d="M4073 6610 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z" fill={svgColor}/>
<path d="M2291 6608 c-5 -13 -12 -38 -16 -55 l-7 -33 70 0 70 0 6 38 c4 20 9
45 12 55 5 15 -2 17 -61 17 -59 0 -66 -2 -74 -22z" fill={solarColor}/>
<path d="M2446 6593 c-12 -75 -14 -73 69 -73 l75 0 0 39 c0 22 3 46 6 55 5 14
-5 16 -69 16 l-74 0 -7 -37z" fill={solarColor}/>
<path d="M2620 6591 c0 -22 -3 -46 -6 -55 -5 -14 6 -16 90 -16 l96 0 0 33 c0
75 -3 77 -96 77 l-84 0 0 -39z" fill={solarColor}/>
<path d="M2820 6598 c0 -74 5 -78 87 -78 l75 0 -6 38 c-14 74 -11 72 -87 72
l-69 0 0 -32z" fill={solarColor}/>
<path d="M2994 6593 c14 -75 12 -73 82 -73 71 0 73 2 52 71 l-11 39 -65 0 -64
0 6 -37z " fill={solarColor}/>
<path d="M4073 6470 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z" fill={svgColor}/>
<path d="M2241 6438 c-31 -90 -32 -88 54 -88 69 0 75 2 80 23 14 63 25 113 25
120 0 4 -31 7 -69 7 l-69 0 -21 -62z" fill={solarColor}/>
<path d="M2424 6473 c-3 -16 -10 -44 -15 -63 -16 -61 -17 -60 80 -60 l89 0 4
68 c3 37 3 70 1 75 -2 4 -38 7 -78 7 -73 0 -75 -1 -81 -27z" fill={solarColor}/>
<path d="M2610 6456 c0 -24 -3 -58 -6 -75 l-6 -31 106 0 106 0 0 44 c0 24 -3
58 -6 75 l-6 31 -94 0 -94 0 0 -44z" fill={solarColor}/>
<path d="M2830 6448 c0 -98 0 -98 96 -98 96 0 95 -1 71 95 l-13 50 -77 3 -77
3 0 -53z" fill={solarColor}/>
<path d="M3015 6478 c3 -13 11 -45 18 -73 l12 -50 78 -3 78 -3 -7 28 c-4 15
-14 48 -23 73 l-17 45 -72 3 c-71 3 -73 2 -67 -20z" fill={solarColor}/>
<path d="M4073 6325 c0 -27 2 -38 4 -22 2 15 2 37 0 50 -2 12 -4 0 -4 -28z" fill={svgColor}/>
<path d="M2687 6323 c-4 -3 -7 -37 -7 -75 0 -66 1 -68 25 -68 24 0 25 2 25 75
0 66 -2 75 -18 75 -10 0 -22 -3 -25 -7z" fill={solarColor}/>
<path d="M6950 6222 c-8 -10 -112 -103 -230 -207 -118 -103 -252 -222 -298
-263 -45 -41 -91 -82 -102 -89 -25 -18 -28 -94 -5 -113 15 -12 33 -4 65 30 3
3 52 48 110 99 58 52 123 110 145 130 216 196 338 301 348 301 7 0 35 -22 62
-48 28 -26 89 -80 135 -121 47 -41 94 -84 106 -95 11 -12 47 -43 79 -71 32
-27 63 -55 69 -60 100 -93 195 -175 203 -175 5 0 22 14 38 32 l28 31 -54 50
c-89 81 -130 118 -214 192 -44 39 -82 72 -85 75 -3 3 -48 43 -100 90 -52 47
-100 90 -106 95 -6 6 -37 33 -69 60 -32 28 -64 56 -71 63 -17 17 -36 15 -54
-6z" fill={loadColor}/>
<path d="M4073 6180 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z" fill={svgColor}/>
<path d="M2410 6112 l-75 -37 187 -3 c104 -1 272 -1 375 0 l188 3 -79 38 -78
37 -222 -1 -221 -1 -75 -36z" fill={solarColor}/>
<path d="M6480 6034 c0 -130 -5 -127 77 -53 67 61 89 101 84 157 -1 8 -24 12
-81 12 l-80 0 0 -116z" fill={loadColor}/>
<path d="M4073 6040 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z" fill={svgColor}/>
<path d="M6945 5964 c-75 -65 -140 -121 -159 -139 -11 -11 -79 -72 -151 -135
-71 -63 -136 -122 -142 -130 -10 -11 -12 -97 -10 -350 l2 -335 154 -3 c91 -1
157 1 160 7 4 5 5 52 4 103 -3 116 4 173 23 193 23 22 286 22 308 -1 18 -17
18 -21 16 -161 -2 -155 -17 -143 171 -143 l159 0 0 339 0 338 -72 64 c-40 35
-97 87 -127 116 -29 29 -56 53 -58 53 -3 0 -20 15 -38 33 -18 17 -46 43 -61
56 -16 13 -52 46 -81 73 -28 26 -55 48 -60 48 -4 0 -21 -12 -38 -26z" fill={loadColor}/>
<path d="M4983 5826 c-58 -19 -136 -70 -166 -109 -13 -18 -37 -57 -52 -87 -25
-48 -29 -67 -29 -145 -1 -82 2 -96 31 -156 39 -79 102 -140 181 -177 83 -38
192 -38 279 2 76 35 144 104 181 184 22 48 26 71 26 147 0 78 -4 98 -29 149
-59 123 -170 197 -304 203 -46 2 -93 -3 -118 -11z m222 -37 c67 -25 141 -94
175 -164 34 -69 36 -207 3 -277 -30 -66 -96 -133 -162 -165 -47 -24 -69 -28
-136 -28 -101 0 -172 32 -239 106 -154 171 -91 447 121 529 66 26 167 26 238
-1z" fill={svgColor}/>
<path d="M4073 5750 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z" fill={svgColor}/>
<path d="M4557 5641 l27 -48 -28 -47 -27 -47 33 14 c18 8 62 27 98 42 36 15
68 30 73 34 4 4 -40 28 -98 54 l-105 46 27 -48z" fill={svgColor}/>
<path d="M4071 5623 c-1 -24 3 -33 15 -33 12 0 14 3 6 13 -5 6 -12 21 -15 32
-3 13 -5 9 -6 -12z" fill={svgColor}/>
<path d="M5980 5609 c0 -6 13 -31 30 -55 l30 -44 -30 -49 c-17 -26 -30 -51
-30 -54 0 -8 64 17 163 62 37 17 67 35 67 40 0 9 -18 18 -125 66 -96 43 -105
46 -105 34z" fill={svgColor}/>
<path d="M4188 5593 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z" fill={svgColor}/>
<path d="M4328 5593 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z" fill={svgColor}/>
<path d="M4473 5593 c15 -2 37 -2 50 0 12 2 0 4 -28 4 -27 0 -38 -2 -22 -4z" fill={svgColor}/>
<path d="M5533 5503 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" fill={svgColor}/>
<path d="M5703 5503 c15 -2 37 -2 50 0 12 2 0 4 -28 4 -27 0 -38 -2 -22 -4z" fill={svgColor}/>
<path d="M5888 5503 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z" fill={svgColor}/>
<path d="M4071 5383 c1 -17 3 -21 6 -10 2 9 13 17 24 17 10 0 19 5 19 10 0 6
-11 10 -25 10 -21 0 -25 -5 -24 -27z" fill={svgColor}/>
<path d="M4180 5400 c0 -5 18 -10 40 -10 22 0 40 5 40 10 0 6 -18 10 -40 10
-22 0 -40 -4 -40 -10z" fill={svgColor}/>
<path d="M4330 5400 c0 -5 18 -10 40 -10 22 0 40 5 40 10 0 6 -18 10 -40 10
-22 0 -40 -4 -40 -10z" fill={svgColor}/>
<path d="M4470 5400 c0 -5 18 -10 40 -10 22 0 40 5 40 10 0 6 -18 10 -40 10
-22 0 -40 -4 -40 -10z" fill={svgColor}/>
<path d="M4610 5400 c0 -5 16 -10 35 -10 19 0 35 5 35 10 0 6 -16 10 -35 10
-19 0 -35 -4 -35 -10z" fill={svgColor}/>
<path d="M4073 5260 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z" fill={svgColor}/>
<path d="M4073 5115 c0 -27 2 -38 4 -22 2 15 2 37 0 50 -2 12 -4 0 -4 -28z" fill={svgColor}/>
<path d="M4073 4970 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z" fill={svgColor}/>
<path d="M3397 4863 c-4 -3 -7 -28 -7 -55 l0 -48 35 0 c37 0 48 15 62 83 5 26
4 27 -39 27 -25 0 -48 -3 -51 -7z" fill={dgColor}/>
<path d="M4073 4830 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z" fill={svgColor}/>
<path d="M3271 4825 c-17 -20 -31 -45 -31 -56 0 -18 6 -20 63 -17 l62 3 3 53
3 52 -34 0 c-27 0 -42 -8 -66 -35z" fill={dgColor}/>
<path d="M3240 4720 c0 -7 -179 -10 -518 -10 -452 0 -520 -2 -540 -16 -22 -15
-22 -16 -22 -315 0 -188 4 -308 10 -320 10 -18 28 -19 655 -19 354 0 650 3
659 6 14 5 16 43 16 325 0 361 5 339 -84 339 -25 0 -46 5 -46 10 0 6 -28 10
-65 10 -37 0 -65 -4 -65 -10z m-327 -74 c22 -17 22 -44 0 -68 -21 -24 -44 -23
-71 2 -27 25 -27 30 -4 58 19 25 49 28 75 8z m209 -3 c22 -20 23 -41 1 -65
-19 -21 -41 -23 -65 -4 -23 17 -23 44 -1 68 20 22 41 23 65 1z m218 -3 c25
-25 25 -34 -2 -60 -26 -24 -51 -26 -72 -4 -26 25 -19 64 14 77 27 10 40 7 60
-13z m-691 -56 c20 -25 21 -40 21 -216 0 -252 13 -238 -216 -238 -158 0 -169
1 -191 22 -13 12 -23 29 -23 39 0 9 -7 19 -15 23 -9 3 -15 18 -15 34 0 16 7
35 15 42 11 9 15 33 15 85 0 56 -4 74 -15 79 -9 3 -15 18 -15 34 0 16 7 35 15
42 8 7 15 18 15 24 0 6 7 22 16 34 15 21 21 22 194 22 l179 0 20 -26z m623
-101 c16 -14 18 -34 18 -194 0 -226 15 -212 -208 -207 -116 2 -163 7 -175 17
-15 12 -17 38 -17 189 0 149 2 178 17 194 14 16 34 18 181 18 140 0 168 -3
184 -17z" fill={dgColor}/>
<path d="M2288 4589 c-16 -9 -18 -30 -18 -218 0 -181 2 -210 16 -215 27 -10
314 -7 335 4 18 10 19 23 19 210 0 167 -2 201 -16 214 -13 13 -42 16 -167 16
-85 0 -160 -5 -169 -11z m282 -109 c0 -19 -7 -20 -120 -20 -113 0 -120 1 -120
20 0 19 7 20 120 20 113 0 120 -1 120 -20z m40 -130 c0 -31 -16 -41 -26 -15
-8 19 2 45 16 45 5 0 10 -13 10 -30z" fill={dgColor}/>
<path d="M2937 4463 c-4 -3 -7 -82 -7 -175 l0 -168 160 0 160 0 0 175 0 175
-153 0 c-85 0 -157 -3 -160 -7z m209 -76 c-20 -30 -36 -57 -36 -61 0 -3 18 -6
40 -6 22 0 40 -3 40 -7 0 -12 -33 -43 -45 -43 -7 0 -19 -7 -26 -17 -22 -26
-110 -93 -122 -93 -8 0 -9 3 -1 8 5 4 27 30 48 57 l38 50 -41 3 c-23 2 -41 7
-41 11 0 4 28 30 63 58 34 28 73 63 86 77 38 41 37 23 -3 -37z" fill={dgColor}/>
<path d="M4073 4540 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z" fill={svgColor}/>
<path d="M4073 4400 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z" fill={svgColor}/>
<path d="M3655 4350 c3 -5 22 -10 41 -10 19 0 34 5 34 10 0 6 -18 10 -41 10
-24 0 -38 -4 -34 -10z" fill={svgColor}/>
<path d="M3795 4350 c3 -5 21 -10 40 -10 19 0 37 5 40 10 4 6 -12 10 -40 10
-28 0 -44 -4 -40 -10z" fill={svgColor}/>
<path d="M3940 4350 c0 -5 18 -10 40 -10 22 0 40 5 40 10 0 6 -18 10 -40 10
-22 0 -40 -4 -40 -10z" fill={svgColor}/>
<path d="M2162 4000 c3 -22 8 -25 53 -28 30 -2 53 -9 58 -18 12 -21 187 -20
187 1 0 13 48 15 375 15 327 0 375 -2 375 -15 0 -12 17 -15 90 -15 71 0 92 3
96 15 4 11 21 15 55 15 47 0 49 1 49 28 l0 27 -670 0 -671 0 3 -25z" fill={dgColor}/>
</g>
</svg>

        </>
    );
};

export default PvDgSyncSvg;